import { HELIOS_API_URL } from '../../../shared/api/config';
import { isHeliosLegacyTokenExpired } from './is-helios-legacy-token-expired';

interface HeliosLegacyTokenResponseBody {
  status: boolean;
  metadata: {
    _id: string;
    type: string;
    iat: number;
    exp: number;
  };
}

/**
 * Verifica si un token es válido. Se usa para los tokens generado con el proceso de autenticación legacy de Helios API.
 * @param token
 * @returns payload y si es válido o no
 */
export async function verifyHeliosLegacyToken(
  token: string,
): Promise<{
  payload: HeliosLegacyTokenResponseBody['metadata'] | null;
  isValid: boolean;
}> {
  // Si el token está expirado, no es válido. Esto lo hacemos para evitar hacer una llamada al backend.
  if (isHeliosLegacyTokenExpired(token)) {
    return {
      payload: null,
      isValid: false,
    };
  }

  const res = await fetch(
    `${HELIOS_API_URL}/validate-token?token=${encodeURIComponent(token)}`,
  );

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const {
    status,
    metadata,
  } = (await res.json()) as HeliosLegacyTokenResponseBody;

  return {
    payload: metadata,
    isValid: status,
  };
}
